import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next",
  "use": "next-usage",
  "viewBox": "0 0 9 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 14\" id=\"next\"><path d=\"M.293 1.707L1.707.293 8.414 7l-6.707 6.707-1.414-1.414L5.585 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol